import useAuthInfo from "./useAuthInfo";
import { IBearerToken } from "helpers/interfaces";
import Constants from "helpers/constants";
import React from "react";

export default function useClientID(): string {
    const authInfo = useAuthInfo();

    const clientID = React.useMemo(() => {
        if (authInfo.signedInWithBearerToken) {
            var localTokenString: string | null = localStorage.getItem(Constants.LocalStorageNames.LOCAL_STORAGE_TOKEN_KEY);
            if (localTokenString === "undefined" || localTokenString === "null") return "";
            var localToken: IBearerToken | null = null;
            if (localTokenString) {
                localToken = JSON.parse(localTokenString);
            }
            return localToken?.clientID ?? "";
        } else {
            return "";
        }
    }, [authInfo]);

    return clientID;
}